import React, { useEffect, useState } from "react";
import { Row, Col, Form, Container } from "react-bootstrap";
import { connect } from "react-redux";
import { getCustomerData } from "../AddCustomer/Customer.action";
import { addBrandApi } from "./Brand.action";
import { setHeading } from "../../../accounts/account.actions";
import { GlobalSpinner } from "../../../../../global/globalFunctions";
import Select from "react-select";
import _ from "lodash";
import Swal from "sweetalert";
import SendIcon from '@mui/icons-material/Send';
import Button from '@mui/material/Button';


const AddBrand = (props) => {
  const [brandName, setBrandName] = useState();
  const [brandDetails, setBrandDetails] = useState();
  const [customerId, setCustomerId] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [visibleAlert, setAlertVisible] = useState(false);
  const [dangerVisibleAlert, setDangerVisibleAlert] = useState(false);


  function SaveBrand() {
    props.addBrandApi({
      brandName: brandName,
      brandDetails: brandDetails,
      customerId: customerId,
      customerName: customerName,
    },
      handleVisible,
      handleDangerVisible
    );
    setCustomerName("")
    setCustomerId("")
    setBrandName("");
    setBrandDetails("");
  }
  const handleVisible = (msg) => {
    setAlertVisible(true);
    setTimeout(() => {
      setAlertVisible(false);
    }, 9000);
    Swal({
      title: "Success",
      text: msg,
      icon: "success",
      button: "Ok",
    });
  };
  const handleDangerVisible = (err) => {
    setDangerVisibleAlert(true);
    setTimeout(() => {
      setDangerVisibleAlert(false);
    }, 9000);
    Swal({
      title: "Error",
      text: err,
      icon: "error",
      button: "Ok",
    });
  };

  const handleChangeCustomer = (selectedOption) => {
    setCustomerId(selectedOption.value);
    setCustomerName(selectedOption.label);
  };
  const getCustomerList = !_.isEmpty(props.customerDataList) && props.customerDataList.map((x) => {
    let data = { value: x._id, label: x.name };
    return data;
  });

  useEffect(() => {
    props.setHeading("Add Brand")
    props.getCustomerData()
  }, []);

  return (
    <>
      {props.isAddingBrand || props.isFetchingCustomer ? (
        <GlobalSpinner />
      ) : (
        <Container fluid>
          <Row>
            <Col>
              <Form.Group className="mb-3" controlId="garana">
                <Form.Label><b>Select Customer *</b></Form.Label>
                <Select
                  isDisabled={_.isEmpty(getCustomerList)}
                  placeholder="Select Customer"
                  onChange={handleChangeCustomer}
                  options={getCustomerList}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group className="mb-3" controlId="garana">
                <Form.Label><b>Brand Name *</b></Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Brand Name"
                  onChange={(e) => setBrandName(e.target.value)}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group className="mb-3" controlId="garana">
                <Form.Label><b>Brand Details </b></Form.Label>
                <Form.Control
                  type="text"
                  value={brandDetails}
                  placeholder="Brand Details"
                  onChange={(e) => setBrandDetails(e.target.value)}
                />
              </Form.Group>
            </Col>
          </Row>

          <div className="sendDiv">
            {_.isEmpty(brandName) || _.isEmpty(customerId) ? (
              <Button variant="contained" endIcon={<SendIcon />} size="large" disabled> SAVE </Button>
            ) : (
              <Button variant="contained" endIcon={<SendIcon />} size="large" onClick={SaveBrand}> SAVE </Button>
            )}
          </div>

        </Container>
      )}
    </>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    addBrandApi: (data, handleVisible, handleDangerVisible) => dispatch(addBrandApi(data, handleVisible, handleDangerVisible)),
    setHeading: (data) => dispatch(setHeading(data)),
    getCustomerData: () => dispatch(getCustomerData()),
  };
};
const mapStateToProps = (state, ownProps) => ({
  isAddingBrand: state.brandReducer.isAddingBrand,
  customerDataList: state.CustomerReducer.customerDataList,
  isFetchingCustomer: state.CustomerReducer.isFetchingCustomer,
});

export default connect(mapStateToProps, mapDispatchToProps)(AddBrand);
